import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImportErrorDialog from './ImportErrorDialog';
import { resetFileUploadFailed } from 'redux/files/FilesActions';

const mapStateToProps = state => ({
  failedImport: state.files.failedUpload,
  errorMessage: state.files.errorMessage
});

const mapDispatchToProps = dispatch => {
  dispatch(resetFileUploadFailed());
  return ({
    filesActions: bindActionCreators({ resetFileUploadFailed }, dispatch)
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportErrorDialog);



// WEBPACK FOOTER //
// ./src/components/importData/comp/importErrorDialog/ImportErrorDialogConnector.js